import { createAction } from "typesafe-actions";
import * as analyticsActions from "./analytics/analytics.actions";
import * as configActions from "./config/config.actions";
import * as modeActions from "./mode/mode.actions";
import * as templateActions from "./templates/templates.actions";
import * as userActions from "./user/user.actions";
import * as workspacesActions from "./workspaces/workspaces.actions";

export const epicFailure = createAction("EPIC_FAILURE")<Error>();

export const resetState = createAction("RESET_STATE")();

export default {
  resetState,
  modeActions,
  configActions,
  workspacesActions,
  userActions,
  templateActions,
  analyticsActions,
  epicFailure,
};
